<template>
  <div
    class="row py-xl"
    :class="`bg-${variant}`"
    data-test="renting-made-easy-section">
    <HomepageSection>
      <template #default>
        <BaseCarousel
          class="w-100"
          auto-scroll-behavior="continuous"
          :items="rentalSteps"
          :items-per-slide="{mobile: 1, tablet: 2, desktop: 4}">
          <template #default="{ item }">
            <div class="step text-center">
              <h3 class="text-orchid">
                {{ item.step }}
              </h3>
              <h3 class="caps">
                <span
                  v-for="(part, index) in item.titleParts"
                  :key="index">
                  {{ part }}
                </span>
              </h3>
              <p class="description pb-lg">
                {{ item.description }}
              </p>
            </div>
          </template>
        </BaseCarousel>
        <GetStartedButton
          location="Renting Made Easy"
          text="Get Personalized Picks"
          class="mt-lg fixed-width"/>
      </template>
    </HomepageSection>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BaseCarousel from '@shared/components/ADORN/BaseCarousel.vue'
import HomepageSection from '@/homepage/components/HomepageSection.vue'
import GetStartedButton from '@/homepage/components/GetStartedButton.vue'

defineProps({
  variant: {
    default: 'white',
    validator: v => v.match(/(white|origami)/),
    type: String
  }
})

const rentalSteps = computed(() => [
  {
    step: 1,
    titleParts: ['Take our ', 'Style Quiz'],
    description: 'Help us get to know you better with a quick 5-minute quiz.'
  },
  {
    step: 2,
    titleParts: ['Choose ', 'your styles'],
    description: 'Select items you love from your closet. We\'ll ship them to your door.'
  },
  {
    step: 3,
    titleParts: ['Wear', 'and enjoy'],
    description: 'Keep your styles as long as you want. Laundry is always on us!'
  },
  {
    step: 4,
    titleParts: ['Swap', 'easily'],
    description: 'When you\'re ready to swap, enjoy your styles until your new case arrives.'
  }
])
</script>

<style lang="scss" scoped>
  .caps span {
    display: block;
  }
  .step {
    display: flex;
    flex-direction: column;
    min-height: 150px;
  }
  .description {
    margin: 0 auto;
    max-width: 204px;
  }
</style>
